import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { color, above, costaTextBold, costaText } from 'ui/src/styles/index'
export default class PageSelect extends PureComponent {
  static defaultProps = {
    activePage: '',
  }

  render() {
    const { selectPage, activePage, disabledFood } = this.props

    return (
      <StyledPageSelect>
        <button
          type="button"
          onClick={() => selectPage('drinks', activePage)}
          className={activePage === 'drinks' ? 'active' : null}
          data-cy="page-select__drinks"
        >
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M33.4 12H13C12.4 12 12 12.6 12 13.2L16 39C15.4 39.6 14.8 40.4 14.6 41C14.4 41.6 14.4 42.4 14.6 43C15 43.6 15.6 43.8 16.2 43.8H30.2C30.8 43.8 31.4 43.4 31.8 43C32.2 42.4 32.2 41.6 31.8 41C31.6 40.4 31 39.4 30.4 39L34.2 13.2C34.2 12.6 33.8 12 33.2 12H33.4Z"
              fill={activePage && activePage !== 'food' ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M34 9C35.3398 9 35.3398 6.87963 35.3398 6.87963C35.4173 6.15659 35.1849 5.42064 34.6943 4.86544C34.2036 4.31025 33.4935 4.00037 32.7576 4.00037H13.5969C12.861 3.98746 12.1637 4.31025 11.6602 4.85253C11.1696 5.40772 10.9372 6.14368 11.0146 6.91837C11.0146 6.91837 11 9 12 9C13 9 32.6602 9 34 9Z"
              fill={activePage && activePage !== 'food' ? color.iconsSelected : color.costaRedFont}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M37.5 21.5497C37.5 19.8433 35.8283 18.6384 34.2094 19.178L30.2094 20.5113C29.1886 20.8516 28.5 21.807 28.5 22.883V25.117C28.5 26.193 29.1886 27.1484 30.2094 27.4887L34.2094 28.822C35.8283 29.3616 37.5 28.1567 37.5 26.4503V21.5497ZM33.2607 16.3319C36.8222 15.1448 40.5 17.7956 40.5 21.5497V26.4503C40.5 30.2044 36.8222 32.8552 33.2607 31.6681L29.2607 30.3347C27.0149 29.5861 25.5 27.4843 25.5 25.117V22.883C25.5 20.5157 27.0149 18.4139 29.2607 17.6653L33.2607 16.3319Z"
              fill={activePage && activePage !== 'food' ? color.iconsSelected : color.costaRedFont}
            />
          </svg>

          <span>Drinks</span>
          <div className={activePage && activePage !== 'food' ? 'underline' : ''} />
        </button>
        <button
          type="button"
          onClick={() => selectPage('food', activePage)}
          className={activePage === 'food' ? 'active' : null}
          disabled={disabledFood}
          data-cy="page-select__food"
        >
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 33C6 32.4477 6.44772 32 7 32H41C41.5523 32 42 32.4477 42 33V43C42 43.5523 41.5523 44 41 44H7C6.44772 44 6 43.5523 6 43L6 33Z"
              fill={
                activePage && activePage !== 'drinks' ? color.iconsSelected : color.costaRedFont
              }
            />
            <path
              d="M6 24C6 23.4477 6.44772 23 7 23H41C41.5523 23 42 23.4477 42 24V28C42 28.5523 41.5523 29 41 29H7C6.44772 29 6 28.5523 6 28V24Z"
              fill={
                activePage && activePage !== 'drinks' ? color.iconsSelected : color.costaRedFont
              }
            />
            <path
              d="M10.9999 5C15.6263 5 33.5065 14.3277 41.4444 18.1375C42.3977 18.5951 42.0618 20 41.0044 20H7.03412C6.51245 20 6.08072 19.599 6.06017 19.0777C5.93723 15.959 5.94073 5 10.9999 5Z"
              fill={
                activePage && activePage !== 'drinks' ? color.iconsSelected : color.costaRedFont
              }
            />
          </svg>

          <span>Food</span>
          <div className={activePage && activePage !== 'drinks' ? 'underline' : ''} />
        </button>
      </StyledPageSelect>
    )
  }
}

const StyledPageSelect = styled.div`
  text-align: center;
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${above.tablet`
    padding-top: 18px;
  `}

  button {
    margin: 0 20px;
    padding: 10px 10;
    ${costaText};
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;

    &:disabled {
      span {
        color: ${color.greyLight};
      }
      svg {
        fill: ${color.greyLight};
      }
      .underline {
        border-color: ${color.greyLight};
      }
    }

    &:focus {
      outline: none;
      box-shadow: rgb(207, 168, 202) 0px 0px 8px 2px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
  }

  span {
    ${costaTextBold}
    color: ${color.costaRedFont};
    display: inline-block;
    padding: 0 5px 7px;
    border-radius: 4px;
    font-size: 20px;
    line-height: 28px;
    margin-top: 14px;
  }

  .active {
    span {
      color: ${color.iconsSelected};
      ${costaTextBold}
    }
    .underline {
      width: 65px;
      margin: auto;
      background-color: ${color.iconsSelected};
      border-top: 4px solid ${color.iconsSelected};
      border-radius: 10px;
    }
  }

  .iconWrapper {
    width: 40px;
    height: 40px;
    margin: 30px auto 15px;
    display: flex;
    justify-content: center;
    align-items: center;

    ${above.tablet`
      width: 51px;
      height: 51px;
    `}

    svg {
      fill: ${color.costaRed};
    }
  }

  .activeIconWrapper {
    svg {
      fill: ${color.iconsSelected};
    }
  }
`
